/**
 * Helper: Manipulate
 * -----------------------------------------------------------------------------
 * Manipulates objects and data.
 * - Add in alphabetical order.
 *
 */

/**
 * Combine two objects using properties as the override.
 * @param {Object} object1 - Original object.
 * @param {Object} object2 - New object, overrides existing object values.
 * @returns {Object}
 */
export function combineObjects(object1, object2) {
  for (const property in object2) {
    if (object2 != null && typeof object2 !== 'undefined') {
      object1[property] = object2[property]
    }
  }

  return object1
}
